import { RoutesGroup } from '@/const';
import routes from './routes';

export default {
    routes,
    group: RoutesGroup.Marketing,
    moduleName: "Notifiche push"
};